import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import 'Components/BundleEndedBanner/BundleEndedBanner.scss';

export default function BundleEndedBanner({ name }) {
  return (
    <div className="bundle-ended-banner-container">
      <div className="bundle-ended-message">
        <div>
          <FontAwesomeIcon icon={faCircleInfo} className="mr-2 d-flex" />
        </div>
        <div>
          <FormattedMessage
            id="bundle-ended-banner.sub"
            defaultMessage="{bundleName}Find our latest best selling bundles below for more amazing savings!"
            values={{
              bundleName: <b><FormattedMessage id="bundle-ended-banner.sorry" defaultMessage="Sorry, {name} has now ended." values={{ name }} />&nbsp;</b>,
            }}
          />
        </div>
      </div>
    </div>
  );
}

BundleEndedBanner.propTypes = {
  name: PropTypes.string.isRequired,
};
